import { render, staticRenderFns } from "./ModalExamConfirmation.vue?vue&type=template&id=253e56de&scoped=true"
import script from "./ModalExamConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalExamConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ModalExamConfirmation.vue?vue&type=style&index=0&id=253e56de&prod&lang=scss&scoped=true"
import style1 from "./ModalExamConfirmation.vue?vue&type=style&index=1&id=253e56de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e56de",
  null
  
)

export default component.exports